import { Email } from "@/interfaces/email";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserEmailsStore = defineStore("userEmails", () => {
  const userEmails = ref<Email[]>([]);

  return {
    userEmails,

    setUserEmails(value: Email[]) {
      userEmails.value = value;
    },
  };
});
